var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 0.900513C-1.42239 1.17651 -2.38335 14.3986 6.80673 16.1005H9.19393C18.3861 14.397 17.421 1.17555 8.00033 0.900513Z",
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19393 10.7571H10.9739L11.3127 8.54691H9.19393V7.11251C9.19393 6.50787 9.48993 5.91843 10.4389 5.91843H11.4023V4.03667C9.33921 3.66499 6.86065 3.77811 6.80673 6.86227V8.54691H4.86705V10.7571H6.80673V16.1005H9.19393V10.7571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.500488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon1);
export default __webpack_public_path__ + "static/media/facebook_icon1.55c89986b14c782c28004de9223df9fb.svg";
export { ForwardRef as ReactComponent };